import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

import ErrorBoundary from 'components/ErrorBoundary';
import { useGetSkills, useUpdateEmployeeInterests } from 'core/api/feed';

const Skills = ({ setStep }) => {
  const { data, isLoading, error } = useGetSkills();
  const { mutate } = useUpdateEmployeeInterests();

  const [selected, setSelected] = useState([]);

  const handleSelect = (targetId) => () => {
    if (selected.includes(targetId)) {
      setSelected(selected.filter((id) => id !== targetId));
    } else {
      setSelected([...selected, targetId]);
    }
  };

  const handleNext = () => {
    mutate({ interests: { skills: selected } });
    setStep(3);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      height="100%"
    >
      <Box>
        <Typography variant="h2" sx={{ mb: 1 }}>
          <FormattedMessage id="onboarding.skills.title" />
        </Typography>
        <Typography color="textSecondary">
          <FormattedMessage id="onboarding.interests.description" />
        </Typography>
        {!isLoading && (
          <ErrorBoundary error={error}>
            <Box mt={4} mb={3}>
              {data
                .filter(({ hideFromUserInterests }) => !hideFromUserInterests)
                .map(({ title, id }) => (
                  <Chip
                    key={id}
                    label={title}
                    variant="outlined"
                    color={selected.includes(id) ? 'secondary' : 'default'}
                    sx={{ mr: 1, mb: 1 }}
                    onClick={handleSelect(id)}
                  />
                ))}
            </Box>
          </ErrorBoundary>
        )}
      </Box>
      <Button
        variant="contained"
        onClick={handleNext}
        sx={{ display: 'block', mx: 'auto' }}
      >
        <FormattedMessage id="action.continue" />
      </Button>
    </Box>
  );
};

Skills.displayName = 'Skills';
export default Skills;
